<template>
  <SysDialog v-model="DIALOG_ATIVO" titulo="Aviso" ocultar-acoes :largura="500">
    <p class="mt-n1 mb-4 text-justify">
      Não foi possível selecionar o fornecedor dos produtos marcados da forma abaixo,
      pois possuem mais de um produto dentro da combinação.
      <span class="font-weight-medium">Faça a seleção manualmente.</span>
    </p>

    <v-card class="mb-3 z-999">
      <div class="d-flex align-center pa-2" style="background: #FFEBEE">
        <v-btn icon disabled>
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <span class="font-weight-medium font-15 text-gray-1000">NOME PRODUTO</span>

        <v-spacer />

        <v-icon color="red">mdi-close-circle</v-icon>
      </div>
    </v-card>
  </SysDialog>
</template>

<script>
import SysDialog from "@/components/padraoDeLayout/SysDialog.vue";

export default {
  components: {SysDialog},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  },
  props: {
    modelValue: Boolean,
  },
  emits: ['update:modelValue'],
  computed: {
    DIALOG_ATIVO: {
      get: function () {
        return this.modelValue;
      },
      set: function (valor) {
        this.$emit('update:modelValue', valor);
      }
    }
  }
}
</script>
